module.exports = "img/flags/DK.a30053a.png";